import React from "react";
import { Col, Row } from "react-bootstrap";
import image from "../../Assets/photo.png";
import ecom from "../../Assets/ecom.png";
import shop from "../../Assets/shopinn.png";
import notes from "../../Assets/notes.png";
import automateAlgosSite from "../../Assets/automateAlgoSite.png";
import automateAlgosProd from "../../Assets/automateAlgosProduct.png";
import stackOver from "../../Assets/StackOverflow.png";
import userman from "../../Assets/UserManagement.png";
function Projects() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <a href="https://stackoverflow-clone-in.netlify.app/">
          <img
            src={stackOver}
            alt="home pic"
            className="img-fluid"
            style={{ maxHeight: "450px" }}
          />
        </a>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <a href="https://automatealgosproduct.netlify.app/">
          <img
            src={automateAlgosProd}
            alt="home pic"
            className="img-fluid"
            style={{ maxHeight: "450px" }}
          />
        </a>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <a href="http://www.automatealgos.in/">
          <img
            src={automateAlgosSite}
            alt="home pic"
            className="img-fluid"
            style={{ maxHeight: "450px" }}
          />
        </a>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <a href="https://user-admin-system.onrender.com/">
          <img
            src={userman}
            alt="home pic"
            className="img-fluid"
            style={{ maxHeight: "450px" }}
          ></img>
        </a>
      </Col>
    </Row>
  );
}
export default Projects;
